import { User, Briefcase, Rocket } from "lucide-react";
import { Reveal } from "@/components/Reveal";

const audiences = [
  {
    icon: User,
    title: "Individuals",
    description:
      "For people who want greater understanding of personal credit, financial literacy and responsible credit-building habits.",
    testId: "audience-individuals",
  },
  {
    icon: Briefcase,
    title: "Entrepreneurs",
    description:
      "For business owners who want to understand how their personal and business financial profiles may affect future financing opportunities.",
    testId: "audience-entrepreneurs",
  },
  {
    icon: Rocket,
    title: "Future Business Owners",
    description:
      "For people preparing to launch businesses who want to understand credit, financial organization and funding readiness before they need financing.",
    testId: "audience-future-owners",
  },
];

export const WhoWeHelp = () => (
  <section data-testid="who-we-help-section" className="bg-[#0E0E12] py-14 lg:py-20">
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <Reveal>
        <p className="text-[11px] font-bold uppercase tracking-[0.24em] text-[#D8B54A]" data-testid="who-we-help-label">
          Who We Help
        </p>
        <h2
          data-testid="who-we-help-heading"
          className="mt-3 max-w-2xl font-heading text-2xl font-bold tracking-tight text-[#F2EEE3] sm:text-3xl lg:text-4xl"
        >
          Built for People Who Want to Understand Their Finances Better.
        </h2>
      </Reveal>
      <div className="mt-10 grid gap-6 md:grid-cols-3">
        {audiences.map((audience, i) => (
          <Reveal key={audience.title} delay={i * 0.1}>
            <div
              data-testid={audience.testId}
              className="group h-full rounded-2xl border border-white/10 bg-[#17171C] p-7 transition-all duration-300 hover:-translate-y-1 hover:border-[#C9A227]/30 hover:shadow-xl hover:shadow-black/40 sm:p-8"
            >
              <span className="flex h-12 w-12 items-center justify-center rounded-xl bg-[#141419] transition-colors duration-300 group-hover:bg-[#C9A227]/10">
                <audience.icon className="h-5 w-5 text-[#D8B54A]" strokeWidth={1.8} />
              </span>
              <h3 className="mt-6 font-heading text-lg font-semibold tracking-tight text-[#F2EEE3] sm:text-xl">
                {audience.title}
              </h3>
              <p className="mt-3 text-sm leading-relaxed text-[#B8B2A6] sm:text-base">{audience.description}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
